export default {
  LayersControl: "Rétegek",
  SettingsControl: "Beállítások",
  settings: {
    language: {
      title: "Nyelv"
    },
    functions: {
      title: "Eszközök",
      print: "Nyomtatás",
      measure: "Mérés"
    },
    layerLabel: "Rétegek",
    transparency: "Áttetszőség",
    dataPrivacy: "Impresszum és adatvédelmi záradék",
    downloadMsg: "Töltse le a City App alkalmazást",
    legend: "Jelmagyarázat",
    backdrop: "Háttér (térkép)",
    embedLinks: "Link a beágyazáshoz"
  },
  buttons: {
    fullscreen: "Teljes képernyő",
    popout: "Térkép megnyitása új ablakban",
    poisAndStreets: "Látványosság",
    routing: "Navigáció",
    close: "Elzár",
    weather3D: "3D időjárás"
  },
  menuPopup: {
    back: "Back to results",
    pois: "Tematikus rétegek",
    streets: "Utcák"
  },
  poiDetails: {
    moreInfo: "Több információ",
    openingHours: "Nyitvatartási idő",
    opened: "Opened",
    closed: "Closed",
    showMore: "Mutass többet",
    showLess: "Mutass kevesebbet",
    altitude: "Magasság",
    zmin: "Min. magasság",
    zmax: "Max. magasság",
    distance: "Távolság",
    time: "Time",
    content: "Tartalom",
    ytitle: "Távolság",
    xtitle: "Magasság"
  },
  measureComponent: {
    colorSelector: "Szín",
    shape: "Rajzelem",
    measure: "Mérés",
    length: "Hossz",
    area: "Terület",
    radius: "Sugár",
    circumference: "Kerület",
    delete: "Mindet törölni"
  },
  rightClickFrame: {
    startPoint: "Válasszon kiindulási pontot",
    endPoint: "Válasszon végpontot",
    whatIsHere: "Mi található itt?",
    print: "Nyomtatás",
    measure: "Mérés"
  },
  routeFrame: {
    routeOptions: "Útlehetőségek",
    highway: "Autópályák",
    tollRoad: "Fizetős utak",
    ferry: "Kompok",
    units: "Egység",
    startPoint: "Útvonal innen ...",
    midPoint: "Midpoint ...",
    endPoint: "Útvonal ide ...",
    metric: "Metrikus (km)",
    imperial: "Birodalmi (mi)",
    via: "keresztül",
    departure: "Indulás:",
    details: "Részletek",
    error: "Hiba történt:",
    getDirections: "Útvonal kiszámítása",
    switchPoints: "Fordított útvonal",
    close: "Navigáció kikapcsolása",
    directions_car: "Autóval",
    directions_bus: "Tömegközlekedéssel",
    directions_bike: "Kerékpárral",
    directions_walk: "Gyalog"
  },
  streetEntry: {num: "H.sz."},
  searchPlaceholder: "Keress érdekes helyeket, utcákat vagy útvonalakat a térképen...",
  searchFrame: {
    previous: "Előző",
    next: "Következő",
    loading: "Loading",
    error: "Hiba történt",
    noResults: "Nem található találat",
    pois: "Látnivaló",
    streets: "Utcák",
    other: "Egyéb"
  },
  general: {
    monday: "Hétfő",
    tuesday: "Kedd",
    wednesday: "Szerda",
    thursday: "Csütörtök",
    friday: "Péntek",
    saturday: "Szombat",
    sunday: "Vasárnap",
    copy: "Másolás"
  },
  printOverlay: {
    titlePlaceholder: "Cím (választható)",
    notesPlaceholder: "Jegyzetek (választható)",
    print: "Nyomtatás",
    close: "Bezárás"
  },
  wfs: {
    intro_description: "Kérjük, válasszon ki egy elemet a térképen a részletek megtekintéséhez.",
    no_elem_found: "Ezen a helyen nem találtunk elemet.",
    unknown_error: "Ismeretlen hiba történt: "
  },
  routing: {
    title: "Navigáció",
    instructionsTitle: "Utasítások",
    showMore: "Több megjelenítése",
    showLess: "Kevesebb megjelenítése",
    startPlaceholder: "Kezdőpont keresése / kattintson a térképre",
    endPlaceholder: "Cél keresése / kattintson a térképre",
    useMyLocation: "Saját helyem használata",
    needBothPoints: "Válassza ki a kezdőpontot és a célt az utasítások megtekintéséhez.",
    loading: "Navigáció betöltése..."
  },
  instructions: {
    // körforgalom
    körforgalom: {icon: "sync", text: "Körforgalom"},
    "a körforgalomban": {icon: "sync", text: "Körforgalom"},

    // enyhén jobbra / balra (înainte de generale)
    "enyhén jobbra forduljon": {icon: "turn_slight_right", text: "Enyhén jobbra"},
    "enyhén jobbra tartson": {icon: "turn_slight_right", text: "Enyhén jobbra"},
    "enyhén jobbra": {icon: "turn_slight_right", text: "Enyhén jobbra"},
    "kissé jobbra": {icon: "turn_slight_right", text: "Enyhén jobbra"},

    "enyhén balra forduljon": {icon: "turn_slight_left", text: "Enyhén balra"},
    "enyhén balra tartson": {icon: "turn_slight_left", text: "Enyhén balra"},
    "enyhén balra": {icon: "turn_slight_left", text: "Enyhén balra"},
    "kissé balra": {icon: "turn_slight_left", text: "Enyhén balra"},

    // jobbra / balra forduljon
    "forduljon jobbra": {icon: "turn_right", text: "Forduljon jobbra"},
    "kanyarodjon jobbra": {icon: "turn_right", text: "Forduljon jobbra"},
    "jobbra forduljon": {icon: "turn_right", text: "Forduljon jobbra"},

    "forduljon balra": {icon: "turn_left", text: "Forduljon balra"},
    "kanyarodjon balra": {icon: "turn_left", text: "Forduljon balra"},
    "balra forduljon": {icon: "turn_left", text: "Forduljon balra"},

    "forduljon élesen jobbra": {icon: "turn_sharp_right", text: "Forduljon élesen jobbra"},
    "élesen jobbra": {icon: "turn_sharp_right", text: "Élesen jobbra"},

    // tarts(on) jobbra / balra
    "tartson jobbra": {icon: "fork_right", text: "Tartson jobbra"},
    "maradjon jobbra": {icon: "fork_right", text: "Tartson jobbra"},
    "jobbra tartson": {icon: "fork_right", text: "Tartson jobbra"},

    "tartson balra": {icon: "fork_left", text: "Tartson balra"},
    "maradjon balra": {icon: "fork_left", text: "Tartson balra"},
    "balra tartson": {icon: "fork_left", text: "Tartson balra"},

    // egyenesen
    "haladjon tovább": {icon: "straight", text: "Haladjon tovább"},
    "haladjon tovabb": {icon: "straight", text: "Haladjon tovább"},
    "haladjon tovább erre": {icon: "straight", text: "Haladjon tovább"},
    "haladjon tovabb erre": {icon: "straight", text: "Haladjon tovább"},
    "haladjon tovább ezen": {icon: "straight", text: "Haladjon tovább"},
    "haladjon tovabb ezen": {icon: "straight", text: "Haladjon tovább"},
    "menjen tovább": {icon: "straight", text: "Menjen tovább"},
    "menjen tovabb": {icon: "straight", text: "Menjen tovább"},
    folytassa: {icon: "straight", text: "Folytassa"},
    "egyenesen haladjon tovább": {icon: "straight", text: "Egyenesen"},
    egyenesen: {icon: "straight", text: "Egyenesen"},

    "maradjon a bal sávban": {icon: "fork_left", text: "Maradjon a bal sávban"},
    "tartsa a bal sávot": {icon: "fork_left", text: "Maradjon a bal sávban"},
    "bal sávban maradjon": {icon: "fork_left", text: "Maradjon a bal sávban"},

    "maradjon a jobb sávban": {icon: "fork_right", text: "Maradjon a jobb sávban"},
    "tartsa a jobb sávot": {icon: "fork_right", text: "Maradjon a jobb sávban"},
    "jobb sávban maradjon": {icon: "fork_right", text: "Maradjon a jobb sávban"},

    "forduljon vissza": {icon: "u_turn_left", text: "Forduljon vissza"},
    "u-turn": {icon: "u_turn_left", text: "Forduljon vissza"},

    waypoint: {icon: "place", text: "Útpont"},
    útpont: {icon: "place", text: "Útpont"}
  },
  rotateOverlay: {
    message: "Kérjük, fordítsa el a telefont álló módba a térkép megtekintéséhez."
  },
  events: {
    title: "Eseménynaptár",
    allEvents: "Összes",
    // allEventsSub: "Esemény",
    loading: "Az események betöltése folyamatban...",
    noEvents: "Nincsenek események a kiválasztott hónapban.",
    seeMore: "Részletek megtekintése",
    information: "Információk az eseményről",
    website: "Weboldal",
    location: "Helyszín"
  }
};
